import Projects from '../components/Projects/Projects';

function ProjectsPage() {
    return (
        <Projects />
    );
}

export default ProjectsPage;